export default __webpack_public_path__ + "locales/zh-CN/CreateEditRoomDialog.json?hash=6cc7b172ea69c2f41158803c9c0cbe59";